// src/pages/LoginPage.tsx
import React, { useContext } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import microsoftLogoUrl from '../assets/images/microsoft-logo.svg';
import { AuthContext } from '../context/AuthContext';

const LoginPage: React.FC = () => {
    const { login } = useContext(AuthContext);

    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
                bgcolor: 'background.default',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Card
                sx={{
                    maxWidth: 360,
                    width: '100%',
                    textAlign: 'center',
                    px: 3,
                    py: 4,
                }}
            >
                <CardContent>
                    <Typography variant="h5" gutterBottom>
                        Welcome to Permanent Record
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>
                        Sign in with your Microsoft account
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={login}
                        startIcon={
                            <Box
                                component="img"
                                src={microsoftLogoUrl}
                                alt="Microsoft logo"
                                sx={{ width: 24, height: 24 }}
                            />
                        }
                        sx={{
                            textTransform: 'none',
                            fontSize: '1rem',
                            fontWeight: 500,
                            py: 1.5,
                        }}
                    >
                        Sign in with Microsoft
                    </Button>
                </CardContent>
            </Card>
        </Box>
    );
};

export default LoginPage;
